var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"about-content-container"},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.customContent)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }